import { ISignOverview } from '../../../../functions/src/shared/contracts/api/GlossContract';
import { Constants } from '@/shared/Constants';
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';

class SignFeedbackService {
    public sessionId = null;
    
    // Use configured Node.js backend for AI endpoints (supports both local and deployed)
    private get AI_BASE_URL(): string {
        return `${Constants.nodeBackendUrl}/api`;
    }

    public async getFeedbackSign(): Promise<ISignOverview> {
        this.sessionId = uuidv4();

        const response = await axios.get<ISignOverview>(`${this.AI_BASE_URL}/feedback/sign`,
            { headers: { sessionid: this.sessionId } });
        return response.data;
    }

    public async analyseRecording(landMarks: any[], signKnowledge: string): Promise<{ gloss: ISignOverview, score: number, feedbackGloss: boolean }[]> {

        const response = await axios.post(
            `${this.AI_BASE_URL}/feedback/search`,
            {
                signKnowledge: signKnowledge,  // Match old code exactly
                landMarks: landMarks,          // Send directly - already numbers
            },
            { headers: { sessionid: this.sessionId } },  // Match old code exactly
        );

        const logId = response.headers && (response.headers['x-log-id'] || response.headers['X-Log-Id'])
        if (logId) {
            (this as any)._lastLogId = logId
        }
        return response.data;
    }

    public async sendAnswers(answers: any): Promise<string> {
        const response = await axios.post<string>(
            `${this.AI_BASE_URL}/feedback/questions`,
            {
                answers,
            },
            { headers: { sessionid: this.sessionId } },
        );
        return response.data;
    }

    public get lastLogId(): string | undefined {
        return (this as any)._lastLogId
    }
}

export const signFeedbackService = new SignFeedbackService();
